module.exports = __webpack_public_path__ + "static/media/S7.6c2136d7.webp";